import React from "react";

export function Pagination(props){


    function renderPages(){
        let pages = [];

        let startPage = Math.max(1, props.selected - Math.floor(10 / 2))
        let endPage = startPage + 10 - 1

        if (endPage > props.pages) {
            endPage = props.pages
            startPage = Math.max(1, endPage - 10 + 1)
        }

        for(let i = startPage; i < endPage; i++){
            pages.push( <li className="page-item"><a className="page-link" href="#" onClick={() => props.select(i)}>{i+1}</a></li>);
        }
        return pages;
    }


    return (

        <nav aria-label="Page navigation example" className={"d-flex justify-content-center"}>
            <ul className="pagination">
                <li className="page-item"><a className="page-link" href="#" onClick={() => props.select(() => {
                    if(props.selected === 0){
                        return 1;
                    }else{
                        return props.selected-1;
                    }
                })}>Previous</a></li>

                {
                    renderPages()
                }


                <li className="page-item"><a className="page-link" href="#" onClick={() => props.select(() => {
                    if(props.selected === 1){
                    return 0;
                }else{
                    return props.selected+1;
                }
                })}>Next</a></li>
            </ul>
        </nav>

    );

}